import { Injectable } from '@angular/core';
import { WebService } from '../services/web.service';

@Injectable({
  providedIn: 'root'
})
export class GroupService {
  accessGroupList: any=[];
  constructor( private webapi: WebService ) { }

  getAccessGroups() {
    return new Promise((resolve, reject) => {
        this.webapi.requestJson('getGroup', null)
        .subscribe(
            data => {
                let response = JSON.parse(data.body);
                this.accessGroupList = [...response.data];
                resolve(true)
            },
            error => {
                return(true)
            }
        )
    })
  }


}